import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('span')(
  ({ theme, isMobile }: { theme: ICustomTheme; isMobile: boolean }) => ({
    flex: '1 0 auto',
    padding: isMobile ? theme.spacing(0) : theme.spacing(6),
  }),
);
